import sign from '@lottery.2.0/mixin/sign.js'
export default sign